<template>
  <div>
    <v-text-field
      :model-value="mask(displayValue)"
      pattern="[0-9]*"
      inputmode="numeric"
      :bg-color="color"
      class="text-center font-size--24 pb-0"
      @update:model-value="(val: string) => onUpdateModelValue(val)"
      @change="$emit('change', $event)"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
      @beforeinput.capture="onBeforeinput"
      :aria-live="notify ? 'assertive' : 'off'"
      :aria-labelledby="labelId"
      :aria-describedby="toolTipId"
      :hide-details="hideDetails"
      maxlength="11"
      required
      :aria-label="labelId"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';

const componentOptions: ComponentOptions = {
  name: 'CurrencyDisplay',
  props: {
    modelValue: {
      type: [Number, String],
      required: true,
    },
    notify: {
      type: Boolean,
      default: false,
    },
    labelId: {
      type: String,
      required: false,
      default: () => '',
    },
    color: {
      type: String,
      required: false,
      default: () => '',
    },
    toolTipId: {
      type: String,
      required: false,
      default: () => '',
    },
    hideDetails: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    displayValue: undefined as string | undefined,
  }),
  methods: {
    cleanAmount(val: string) {
      return val.replace(/[^0-9]/g, '');
    },
    onBeforeinput(event: InputEvent) {
      if (/[^0-9]/.test(event.data ?? '')) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    onUpdateModelValue(val: string) {
      this.displayValue = val;
      const cleaned = this.cleanAmount(val);
      if (cleaned !== String(this.modelValue)) {
        this.$emit('update:modelValue', cleaned);
      }
    },
    mask(value: string) {
      if (!value) return '';
      const clean = this.cleanAmount(value);
      return Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        useGrouping: true,
      }).format(Number(clean));
    },
  },
  watch: {
    modelValue(value) {
      if (value.length === 0 || (value.length > 0 && +value === 0)) {
        return;
      }
      this.displayValue = `${+value}`;
    },
  },
  mounted() {
    this.displayValue = `${this.modelValue}`;
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="css" scoped>
:deep(.v-input .v-field__input) {
  text-align: center !important;
}
</style>
